


























import "./project-copy.less";
import Vue from "vue";
import iForm from "iView";
import moment from "moment";
import { Model } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import VueTagsInput from "@johmun/vue-tags-input";

let _ = require("lodash");

export default Vue.extend({
  name: "project-copy",
  components: {
    VueTagsInput
  },
  props: {
    project: Object,
    showEditor: Boolean
  },
  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: "Please fill in the Project Name",
            trigger: "blur"
          },
          {
            type: "string",
            max: 40,
            message: "Please limit your Project Name to max 40 characters. Thanks!",
            trigger: "blur"
          }
        ],
        description: [
          {
            type: "string",
            max: 1200,
            message: "Please limit your Project Description to max 1,200 characters. Thanks!",
            trigger: "blur"
          }
        ],
        hashTagList: [
          {
            type: "array",
            required: true,
            message: "Please fill in the Grouping Tags"
          }
        ]
      },
      tag: "",
      tags: [],
      currentProject: {
        name: null,
        description: "",
        hashTags: "",
        hashTagList: []
      }
    };
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        this.currentProject.name = this.project.name;
        this.currentProject.description = this.project.description;
        this.currentProject.hashTags = this.project.hashTags;
        this.currentProject.hashTagList = this.currentProject.hashTags ? JSON.parse(this.currentProject.hashTags) : [];
      }
    }
  },
  computed: {
    showModal(): any {
      return this.showEditor;
    }
  },
  methods: {
    handleHidden(visible) {
      if (!visible) {
        try {
          (this.$refs.SetupForm as any).resetFields();
        } catch (error) {}
      }
    },
    handleSave() {
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      let form = this.$refs.ProjectForm;

      (this.$refs.SetupForm as any).validate((valid: boolean) => {
        if (valid) {
          let projectDto = {
            id: this.project.id,
            name: this.currentProject.name,
            description: this.currentProject.description,
            hashTags: JSON.stringify(this.currentProject.hashTagList)
          };

          let actionName = "project/copy";
          let context = this;
          context.$store.dispatch(actionName, { data: projectDto }).then(response => {
            context.$emit("cancel");
            target.disabled = false;
          });
        } else {
          target.disabled = false;
        }
      });
    }
  }
});
